import { render, staticRenderFns } from "./ModalTiersPappers.vue?vue&type=template&id=388b124d&"
import script from "./ModalTiersPappers.vue?vue&type=script&lang=js&"
export * from "./ModalTiersPappers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports